import template from './chronology-inquiry-table.pug';

export const ChronologyInquiryTableComponent = {
  template,
  bindings: {
    chronology: '<',
  },
  controller: class ChronologyInquiryTableComponent {
    constructor(Inquiry, $async, $log) {
      'ngInject';

      this.Inquiry = Inquiry;
      this.$log = $log;

      this.recordPreview = $async(this.recordPreview.bind(this));
    }

    $onInit() {}


    async recordPreview(selectedRecord) {
      try {
        const record = await this.Inquiry.find(selectedRecord.id);
        await this.Inquiry.previewModal(record);
      } catch (e) {
        this.$log.error(e);
      }
    }
  }
};
